// Sign-up pop-up (sections/signup-popup.liquid). Opens at most once a page view: on a desktop pointer when it
// leaves through the top of the window (heading for the tabs or the address bar), on touch after half a page of
// scrolling, never in the first few seconds. A dismissal keeps it away for 30 days; a sign-up keeps it away for
// good, and so does arriving from a Klaviyo email (already on the list). The form itself is wired by
// plate-forms.js, which fires plate:joined on success.
(() => {
  const dialog = document.querySelector('[data-signup-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const STORAGE_KEY = 'lunthra:signup';
  const SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;
  const MIN_DWELL_MS = 4000;
  const MIN_SCROLL_PX = 300;
  const { code, root, sectionId, copied, copyError } = dialog.dataset;

  const readState = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  };
  const writeState = (state) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // Private mode or blocked storage: the pop-up may show again next visit, which is acceptable.
    }
  };

  let joined = false;

  dialog.querySelectorAll('[data-popup-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });
  // A click that lands on the <dialog> itself, not its panel, is a click on the backdrop.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!joined && dialog.dataset.designMode !== 'true') writeState({ dismissedAt: Date.now() });
  });

  const copyButton = dialog.querySelector('[data-popup-copy]');
  const copiedLine = dialog.querySelector('[data-popup-copied]');
  copyButton.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(code);
      copiedLine.textContent = copied;
    } catch (error) {
      copiedLine.textContent = copyError;
    }
    copiedLine.hidden = false;
  });

  dialog.addEventListener('plate:joined', async () => {
    joined = true;
    writeState({ joined: true });
    if (navigator.clipboard) copyButton.hidden = false;
    // Shopify's /discount/<code> link stores the code on the visitor's cart, so checkout applies it without typing.
    try {
      const response = await fetch(`${root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
      if (response.ok) dialog.querySelector('[data-popup-applied]').hidden = false;
    } catch (error) {
      // The code is on screen to copy; nothing else to do.
    }
  });

  // Theme editor: show the pop-up while its section is selected, and never trigger it on its own.
  if (dialog.dataset.designMode === 'true') {
    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === sectionId && !dialog.open) dialog.showModal();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId === sectionId) dialog.close();
    });
    return;
  }

  const state = readState();
  if (state.joined) return;
  if (state.dismissedAt && Date.now() - state.dismissedAt < SNOOZE_MS) return;
  const params = new URLSearchParams(window.location.search);
  if (params.has('_kx') || params.get('utm_source') === 'klaviyo') return;

  const loadedAt = Date.now();
  let opened = false;

  const open = () => {
    if (opened || Date.now() - loadedAt < MIN_DWELL_MS) return;
    // Never on top of the menu or the bag; a later trigger can still open it.
    if (document.querySelector('dialog[open]')) return;
    opened = true;
    stop();
    dialog.showModal();
  };

  const onMouseOut = (event) => {
    if (!event.relatedTarget && event.clientY <= 0) open();
  };
  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (window.scrollY >= MIN_SCROLL_PX && window.scrollY >= scrollable / 2) open();
  };

  const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const stop = () => {
    document.removeEventListener('mouseout', onMouseOut);
    window.removeEventListener('scroll', onScroll);
  };
  if (desktopPointer) {
    document.addEventListener('mouseout', onMouseOut);
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
